import type { ComponentProps } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { Toast as ToastPrimitive } from 'radix-ui';

import styles from './Toaster.module.scss';
import { useToast } from './useToast';

const toastVariants = cva(styles.root, {
  variants: {
    variant: {
      default: styles.default,
      error: styles.error,
      success: styles.success,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ToastProps = ComponentProps<typeof ToastPrimitive.Root>;

export type ToasterToast = ToastProps &
  VariantProps<typeof toastVariants> & {
    id: string;
    title?: React.ReactNode;
    description?: React.ReactNode;
    ctaButton?: React.ReactNode;
  };

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastPrimitive.Provider duration={4500}>
      {toasts.map(
        ({ id, title, description, ctaButton, variant, ...props }) => (
          <ToastPrimitive.Root
            key={id}
            className={toastVariants({ variant })}
            {...props}
          >
            {title && (
              <ToastPrimitive.Title className={styles.title}>
                {title}
              </ToastPrimitive.Title>
            )}
            {description && (
              <ToastPrimitive.Description className={styles.description}>
                {description}
              </ToastPrimitive.Description>
            )}
            {ctaButton}
          </ToastPrimitive.Root>
        ),
      )}
      <ToastPrimitive.Viewport className={styles.viewport} />
    </ToastPrimitive.Provider>
  );
}
